export default {
  title: '空间介绍',
  subtitle:
    '支付宝空间站体验包含12个固定互动体验项目，其中部分体验项目需要现场排号体验，详情可咨询现场工作人员，丰富精彩的奇妙之旅等你来探索。',

  exhibits: [
    {
      title: '遇见蚂蚁森林',
      subtitle: '绿植墙上的微缩景观来自蚂蚁森林嘉塘保护地，栖息着藏狐、雪豹、藏野驴、黑颈鹤等多种珍稀保护动物。而景观上方悬挂了蚂蚁森林代表性植物样本，分别是侧柏、沙棘、胡杨、山桃、杨柴、冷杉。欢迎你在这里拍照打卡留念。',
      body: '绿植墙上的微缩景观来自蚂蚁森林嘉塘保护地，栖息着藏狐、雪豹、藏野驴、黑颈鹤等多种珍稀保护动物。而景观上方悬挂了蚂蚁森林代表性植物样本，分别是侧柏、沙棘、胡杨、山桃、杨柴、冷杉。欢迎你在这里拍照打卡留念。',
      banner: require('src/assets/intro/list20231114001.jpg'),
    },
    {
      title: '探索蚂蚁森林',
      subtitle: '前方透明球里展示有蚂蚁森林里的代表性植物种子。你可以轻触感应球加速时间流转，屏幕中漂浮着的种子便会破土而出，生长成为树木。最后定格在相应树种的植物百科信息。      ',
      body: '前方透明球里展示有蚂蚁森林里的代表性植物种子。你可以轻触感应球加速时间流转，屏幕中漂浮着的种子便会破土而出，生长成为树木。最后定格在相应树种的植物百科信息。',
      banner: require('src/assets/intro/list20231114002.png'),
    },
    {
      title: '我的蚂蚁森林',
      subtitle: '你可以通过扫码展示自己在蚂蚁森林的专属绿色公益成绩单，还将看到实景拍摄的蚂蚁森林保护地。',
      body: '你可以通过扫码展示自己在蚂蚁森林的专属绿色公益成绩单，还将看到实景拍摄的蚂蚁森林保护地。',
      banner: require('src/assets/intro/list01.jpg'),
    },
    {
      //
      title: '飞跃蚂蚁森林',
      subtitle:
        '你将乘上魔幻座驾，跟随绿色能量球，领略上海到阿拉善一路沿途的美景，与蚂蚁森林共创情感绿洲！',
      body:
        '你将乘上魔幻座驾，跟随绿色能量球，领略上海到阿拉善一路沿途的美景，与蚂蚁森林共创情感绿洲！',
      banner: require('src/assets/intro/list02.jpg'),
    },
    {
      title: '天空之眼',
      subtitle:
        '你可以通过手势操作，控制“大山雀”完成隔空圈地，帮助NPC农户获得助农金。该互动体验由网商银行“大山雀”团队提供技术指导。',
      body:
        '你可以通过手势操作，控制“大山雀”完成隔空圈地，帮助NPC农户获得助农金。该互动体验由网商银行“大山雀”团队提供技术指导。',
      banner: require('src/assets/intro/list03.jpg'),
    },
    {
      title: '零碳行动',
      subtitle:
        '你可以通过摇骰子触发不同游戏环节，了解日常生活中的绿色减排行为和高碳排行为。该互动内容由中环联合认证中心（CEC）提供技术支持。',
      body:
        '你可以通过摇骰子触发不同游戏环节，了解日常生活中的绿色减排行为和高碳排行为。该互动内容由中环联合认证中心（CEC）提供技术支持。',
      banner: require('src/assets/intro/list04.jpg'),
    },
    {
      title: '公益画廊',
      subtitle: '你可以看到曾在支付宝公益平台展出过的公益画作，也欢迎你免费下载。',
      body: '你可以看到曾在支付宝公益平台展出过的公益画作，也欢迎你免费下载。',
      banner: require('src/assets/intro/list05.jpg'),
    },
    {
      title: '拯救消失的能量',
      subtitle: '你可以在这里肆意挥洒热情和汗水，在未来城市穿梭，与同伴进行能量球收集比拼，用最酷的姿势拥有最多的能量。获得的绿色能量将同步到你的蚂蚁森林账户中。',
      body: '你可以在这里肆意挥洒热情和汗水，在未来城市穿梭，与同伴进行能量球收集比拼，用最酷的姿势拥有最多的能量。获得的绿色能量将同步到你的蚂蚁森林账户中。',
      banner: require('src/assets/intro/list06.jpg'),
    },
    {
      title: '微笑商店',
      subtitle: '你可以体验智慧购物畅爽便捷体验，微笑刷脸轻松购，还有惊喜盲盒等你来抽取，快来看看谁是真“欧皇”吧！',
      body: '你可以体验智慧购物畅爽便捷体验，微笑刷脸轻松购，还有惊喜盲盒等你来抽取，快来看看谁是真“欧皇”吧！',
      banner: require('src/assets/intro/list07.jpg'),
    },
    {
      title: '一堂金融必修课',
      subtitle: '你可以观看金融知识科普的视频课，趣味解说助你轻松掌握金融知识。该课程由蚂蚁金融教育基地和中国青年报联合出品，中央财经大学金融学院提供学术支持。',
      body: '你可以观看金融知识科普的视频课，趣味解说助你轻松掌握金融知识。该课程由蚂蚁金融教育基地和中国青年报联合出品，中央财经大学金融学院提供学术支持。',
      banner: require('src/assets/intro/list20231114003.png'),
    },
    {
      title: '金融特搜队',
      subtitle: '你可以通过手势操作穿越古今，收集金融能量，通过答题挑战击败入侵飞船，在寓教于乐中习得金融知识。该互动游戏是“星海计划”青少年金融知识科普形式之一。',
      body: '你可以通过手势操作穿越古今，收集金融能量，通过答题挑战击败入侵飞船，在寓教于乐中习得金融知识。该互动游戏是“星海计划”青少年金融知识科普形式之一。',
      banner: require('src/assets/intro/list20231114004.png'),
    },
    {
      title: '公益足迹',
      subtitle: '支付宝空间站致力于打造以“数字普惠、低绿色碳、科技创新、开放生态”为主题的社会化绿色公益开放空间，建立蚂蚁集团与社会公益链接的窗口与桥梁。你可以在这里浏览支付宝空间站与社会生态链接留下的足迹。',
      body: '支付宝空间站致力于打造以“数字普惠、低绿色碳、科技创新、开放生态”为主题的社会化绿色公益开放空间，建立蚂蚁集团与社会公益链接的窗口与桥梁。你可以在这里浏览支付宝空间站与社会生态链接留下的足迹。',
      banner: require('src/assets/intro/list20231114005.png'),
    },
  ],
}
